<script setup>
  import {ref} from "vue";

  import ComponentDemodataDialog from "@components/Dialogs/DemodataDialog/DemodataDialog.vue";
  import {MedButton, MedIcon, MedLink} from "@pharma4u/medicheck-components";

  import DashboardWidget from "./Widget.vue";

  defineOptions({
    name: "DashboardFirstStepsWidgetWide",
  });

  const refDemoDataDialog = ref(null);

  const openDemoDataDialog = () => {
    refDemoDataDialog.value.open();
  };
</script>

<template>
  <div>
    <DashboardWidget :test-id="getTestId('first-steps')">
      <template #title>
        <MedButton
          as="inertia"
          flat
          align="left"
          :href="$route('documents.index')"
          :data-test="getTestId('first-step-widget-route-to-document-index-inertia-link-icon-button')"
        >
          <span class="flex rounded-full bg-mcblue p-1.5 font-normal text-white">
            <MedIcon icon="question_mark" size="lg" />
          </span>

          Erste Schritte
        </MedButton>
      </template>

      <template #default>
        <div
          class="grid grid-cols-1 gap-2 lg:gap-12"
          :class="{'lg:grid-cols-3': $page.props.can.create_records, 'lg:grid-cols-2': !$page.props.can.create_records}"
        >
          <p>
            Neueinsteigern empfehlen wir einen Blick in unsere

            <template v-if="$page.props.client.license.is_connect">
              <!-- Gebrauchsanweisung Connect -->
              <MedLink
                class="font-semibold"
                variant="primary"
                target="_blank"
                :data-test="getTestId('first-step-widget-merchandise-management-link')"
                href="https://medicheck.pharma4u.de/url-redirect/manual-medicheck-wawi"
              >
                Gebrauchsanweisung MediCheck Connect
              </MedLink>

              (PDF-Datei).
            </template>

            <template v-else-if="$page.props.client.license.is_pro">
              <!-- Gebrauchsanweisung Online Pro (2 Versionen, kurz und lang) -->
              <MedLink
                class="font-semibold"
                variant="primary"
                href="https://medicheck.pharma4u.de/url-redirect/short-manual-medicheck"
                target="_blank"
                :data-test="getTestId('first-step-widget-instructions-short-link')"
              >
                Kurzanleitung MediCheck Online Pro
              </MedLink>

              oder die
              <MedLink
                variant="primary"
                class="font-semibold"
                href="https://medicheck.pharma4u.de/url-redirect/manual-medicheck"
                target="_blank"
                :data-test="getTestId('first-step-widget-instructions-link')"
              >
                Gebrauchsanweisung MediCheck Online Pro
              </MedLink>

              (PDF-Dateien).
            </template>
          </p>

          <p>
            Weitere hilfreiche Dokumente finden Sie in unseren

            <MedLink
              as="inertia"
              variant="primary"
              class="font-semibold"
              :href="$route('documents.index')"
              :data-test="getTestId('first-step-widget-route-to-document-index-inertia-link')"
            >
              Arbeitshilfen
            </MedLink>

            (jederzeit im Hauptmenü unter „mehr“).
          </p>

          <p v-if="$page.props.can.create_records">
            Wenn Sie den MediCheck selbst erkunden möchten, bieten sich unsere

            <MedLink
              as="button"
              variant="primary"
              class="font-semibold"
              :data-test="getTestId('first-step-widget-open-demo-data-dialog-link')"
              @click.prevent="openDemoDataDialog()"
            >
              Beispielfälle
            </MedLink>

            an.
          </p>
        </div>
      </template>
    </DashboardWidget>

    <ComponentDemodataDialog ref="refDemoDataDialog" />
  </div>
</template>
